
export const config: any = {

  defaultLocale: 'de',

  API_URL: '/assets/api',
};
